import clsx from 'clsx';
import type { HTMLAttributes, ReactNode } from 'react';

import styles from './CmsSection.module.scss';

export interface CMSSectionProps extends HTMLAttributes<HTMLElement> {
  children: ReactNode;
  /** Whether to apply bottom margin spacing. Defaults to true. */
  withMargin?: boolean;
}

/**
 * Base wrapper component for CMS sections.
 * Renders a semantic <section> element with optional margin spacing.
 */
export function CMSSection({ children, className, withMargin = true, ...props }: CMSSectionProps) {
  return (
    <section
      className={clsx(styles.section, withMargin && styles.withMargin, className)}
      data-testid="CMSSection"
      {...props}
    >
      {children}
    </section>
  );
}

CMSSection.displayName = 'CMSSection';
